import axiosIns from "@/api/axios";
import querystring from "query-string";

export const GET_LIST = (params) => {
  return axiosIns.get(`/site-mappings?${params}`);
};

export const SAVE_DATA = (payload) => {
  return axiosIns.post(`/site-mapping/save`, payload);
};

export const REMOVE_DATA = (site_id) => {
  return axiosIns.delete(`/site-mapping/${site_id}/remove`);
};
